import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { LoaderService } from 'src/app/Services/loader.service';
import { WebsiteService } from 'src/app/Services/website.service';

@Component({
  selector: 'app-home-page',
  templateUrl: './home-page.component.html',
  styleUrls: ['./home-page.component.css']
})
export class HomePageComponent implements OnInit {

  quarter:Number = 1;
  year:Number = 2019;
  kpis:any;
  bcs:any;
  selectedkpi:any = {};
  selectedBc:any = {};

  kpiTable:any={};
  bcTable:any={};

  constructor(private route: ActivatedRoute,
    private loader: LoaderService,
    private websiteser: WebsiteService) { }

  ngOnInit() {
    setTimeout(() => {
      this.loader.hideLoader();
    }, 300);

    this.kpis = this.route.snapshot.data.data.result;
    this.bcs = this.route.snapshot.data.bcs.result;
    this.selectedkpi = this.kpis[0];
    this.selectedBc = this.bcs[0];
    this.getAllData();
  }

  selectKpi(id){
    this.loader.showLoader();
    this.selectedkpi = this.kpis.filter((item) => item.id == id)[0];
    this.getKpisData();
  }

  selectBc(id){
    this.loader.showLoader();
    this.selectedBc = this.bcs.filter((item) => item.id == id)[0];
    this.getBCsData();
  }

  getKpisData(){
    this.websiteser.GetKpiDashboard(this.selectedkpi.id, this.year, this.quarter).subscribe((data:any)=>{
      this.kpiTable = data.result;
      this.loader.hideLoader();
    })
  }

  getBCsData(){
    this.websiteser.GetBcDashboard(this.selectedBc.id, this.year, this.quarter).subscribe((data:any)=>{
      this.bcTable = data.result;
      this.loader.hideLoader();
    })
  }

  getAllData(){
    this.loader.showLoader();
    this.getKpisData();
    this.getBCsData();
  }

}
